(function() {
  'use strict';
  /* global $, angular */

  angular.module('Milestone').directive('msDragCarousel', ['$timeout', function($timeout) {
    var DRAG_THRESHOLD = 10;
    var COMMIT_RATIO = 0.18;
    var COMMIT_VELOCITY = 0.35;
    var SNAP_MS = 280;

    return {
      restrict: 'A',
      link: function(scope, element) {
        var root = element[0];
        var viewport = root.querySelector('.gallery-modal-slider-viewport');
        var track = root.querySelector('.gallery-modal-slider-track');
        var index = 0;
        var width = 0;
        var dragging = false;
        var tracking = false;
        var startX = 0;
        var startY = 0;
        var currentX = 0;
        var startTime = 0;
        var dragOffset = 0;
        var swallowClick = false;

        function slideEls() {
          return track ? track.querySelectorAll('.gallery-modal-slider-slide') : [];
        }

        function count() {
          return slideEls().length;
        }

        function wrap(value) {
          var total = count();
          if (total < 1) {
            return 0;
          }
          return (value + total) % total;
        }

        function measure() {
          width = viewport ? viewport.clientWidth : root.clientWidth;
          if (!width) {
            width = $(root).width();
          }
          var slides = slideEls();
          var i;
          for (i = 0; i < slides.length; i++) {
            slides[i].style.flex = '0 0 ' + width + 'px';
            slides[i].style.width = width + 'px';
          }
        }

        function render(animate) {
          if (!track) {
            return;
          }
          measure();
          if (animate) {
            track.style.transition = 'transform ' + SNAP_MS + 'ms ease';
          } else {
            track.style.transition = 'none';
          }
          var x = -(index * width) + dragOffset;
          track.style.transform = 'translate3d(' + x + 'px,0,0)';
          scope.gallerySlideIndex = index;
        }

        function goTo(nextIndex, animate) {
          index = wrap(nextIndex);
          dragOffset = 0;
          render(animate);
        }

        function getPoint(e) {
          var src = e.originalEvent || e;
          var touch = (src.touches && src.touches[0]) || (src.changedTouches && src.changedTouches[0]);
          if (touch) {
            return { x: touch.clientX, y: touch.clientY };
          }
          return { x: e.clientX, y: e.clientY };
        }

        function swallowNextClick() {
          swallowClick = true;
          window.setTimeout(function() {
            swallowClick = false;
          }, 400);
        }

        function onClickCapture(e) {
          if (!swallowClick) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          swallowClick = false;
        }

        function onStart(e) {
          if ($(e.target).closest('.gallery-modal-slider-prev, .gallery-modal-slider-next, .gallery-modal-slider-dots, .btn-close').length) {
            return;
          }
          if (e.type === 'mousedown' && e.which !== 1) {
            return;
          }
          if (count() < 2) {
            return;
          }

          var point = getPoint(e);
          dragging = true;
          tracking = false;
          startX = point.x;
          startY = point.y;
          currentX = startX;
          startTime = Date.now();
          measure();
          track.style.transition = 'none';
          e.stopPropagation();
        }

        function onMove(e) {
          if (!dragging) {
            return;
          }

          var point = getPoint(e);
          var dx = point.x - startX;
          var dy = point.y - startY;

          if (!tracking) {
            if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) {
              return;
            }
            if (Math.abs(dy) > Math.abs(dx)) {
              dragging = false;
              return;
            }
            tracking = true;
            root.classList.add('is-grabbing');
          }

          currentX = point.x;
          dragOffset = currentX - startX;
          render(false);
          if (e.cancelable) {
            e.preventDefault();
          }
          e.stopPropagation();
        }

        function onEnd(e) {
          if (!dragging && !tracking) {
            return;
          }

          if (tracking) {
            var dx = currentX - startX;
            var elapsed = Math.max(Date.now() - startTime, 1);
            var velocity = Math.abs(dx) / elapsed;
            var threshold = width * COMMIT_RATIO;
            var nextIndex = index;

            if ((dx < 0 && Math.abs(dx) > threshold) || (dx < 0 && velocity > COMMIT_VELOCITY)) {
              nextIndex = index + 1;
            } else if ((dx > 0 && Math.abs(dx) > threshold) || (dx > 0 && velocity > COMMIT_VELOCITY)) {
              nextIndex = index - 1;
            }

            goTo(nextIndex, true);
            swallowNextClick();
            if (e) {
              e.preventDefault();
              e.stopPropagation();
            }
            if (!scope.$$phase) {
              scope.$apply();
            }
          }

          dragging = false;
          tracking = false;
          root.classList.remove('is-grabbing');
        }

        scope.prev = function() {
          if (count() < 2) {
            return;
          }
          goTo(index - 1, true);
        };

        scope.next = function() {
          if (count() < 2) {
            return;
          }
          goTo(index + 1, true);
        };

        scope.goToSlide = function(i) {
          goTo(i, true);
        };

        element.on('dragstart', 'img', function(e) {
          e.preventDefault();
        });
        element.on('mousedown.msDragCarousel', onStart);
        $(document).on('mousemove.msDragCarousel', onMove);
        $(document).on('mouseup.msDragCarousel', onEnd);

        root.addEventListener('touchstart', onStart, { passive: true });
        root.addEventListener('touchmove', onMove, { passive: false });
        root.addEventListener('touchend', onEnd, { passive: false });
        root.addEventListener('touchcancel', onEnd, { passive: false });
        document.addEventListener('click', onClickCapture, true);

        $(window).on('resize.msDragCarousel', function() {
          render(false);
        });

        scope.$watch(function() {
          return count();
        }, function() {
          index = 0;
          dragOffset = 0;
          $timeout(function() {
            render(false);
          }, 0);
        });

        scope.$on('$destroy', function() {
          $(document).off('.msDragCarousel');
          $(window).off('.msDragCarousel');
          element.off('.msDragCarousel');
          root.removeEventListener('touchstart', onStart);
          root.removeEventListener('touchmove', onMove);
          root.removeEventListener('touchend', onEnd);
          root.removeEventListener('touchcancel', onEnd);
          document.removeEventListener('click', onClickCapture, true);
        });
      }
    };
  }]);
})();
